module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Bretzwil-6ad36e2c40c19f4caf2fb15dfe1815bd.svg";